export default {
    AccountSecurityPolicy: {
      top: {
        security: 'Password Security Policy',
        Default: 'Default Password for New Users',
        DefaultRules: 'Please enter the default password for new users',
        Minlength: 'Minimum Password Length',
        MinlengthRules: 'Please enter the minimum password length',
        Maxlength: 'Maximum Password Length',
        MaxlengthRules: 'Please enter the maximum password length',
        lowercase: 'Minimum Number of Lowercase Letters',
        lowercaseRules: 'Please enter the minimum number of lowercase letters',
        uppercase: 'Minimum Number of Uppercase Letters',
        uppercaseRules: 'Please enter the minimum number of uppercase letters',
        special: 'Minimum Number of Special Characters',
        specialRules: 'Please enter the minimum number of special characters',
        oldpassword: 'Allow Reusing Old Passwords for New Passwords',
        loginname: 'Allow Using Login Name as Password',
      },
      bottom: {
        security: 'Login Security Policy',
        Maxerrors: 'Maximum Number of Password Errors',
        MaxerrorsRules: 'Please enter the maximum number of password errors',
        Maxrecent: 'Maximum Number of Recent Passwords',
        errorscode: 'Verify Password with Captcha after a Certain Number of Errors',
        verification: 'Enable Image Captcha',
        locked: 'Allow Locking User Accounts',
        duration: 'Lock Duration (in seconds)',
        durationRules: 'Please enter the lock duration (in seconds)',
        PC: 'Allow Multiple Logins on PC',
        Mobile: 'Allow Multiple Logins on Mobile',
        initial: 'Force Users to Change Initial Password',
        after: 'Require Users to Log in Again After Changing Password',
        secondary: 'Two-Factor Authentication',
      }
    },
};
